import { gql } from 'src/__generated__';

const TRIGGER_DATA_EXTRACTION = gql(`#graphql
  mutation TriggerDataExtraction(
    $config: InputTriggerDataExtractionConfig!
    $requestConfig: InputTriggerDataExtractionRequestConfig!
    $request: InputTriggerDataExtractionRequest!
  ) {
    triggerDataExtraction(config: $config, requestConfig: $requestConfig, request: $request)
  }
`);

export default TRIGGER_DATA_EXTRACTION;
